import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import s from './index.module.css';

const Button = ({ disabled, className, view, background, type, onClick, onMouseDown, children, size, id }) => (
  <button
    id={id}
    disabled={disabled}
    className={cx(s.button, className, {
      [s.view_button]: view === 'button',
      [s.background_white]: background === 'white',
      [s.background_blue]: background === 'blue',
      [s.background_red]: background === 'red',
      [s.medium]: size === 'medium',
      [s.big]: size === 'big',
    })}
    type={type || 'button'}
    onClick={onClick}
    onMouseDown={onMouseDown}
  >
    {children}
  </button>
);

Button.propTypes = {
  view: PropTypes.oneOf(['button']),
  background: PropTypes.oneOf(['white', 'blue', 'red']),
  type: PropTypes.oneOf(['button', 'submit']),
  size: PropTypes.oneOf(['medium', 'big']),
  onClick: PropTypes.func,
  onMouseDown: PropTypes.func,
};

export default Button;
